import { Box, Button, Checkbox, FormControlLabel } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import { getEvent, putEventConditions } from '../../api/events';
import { addFlag, dropFlag, hasFlag } from '../../utils/maskUtils.ts';


const defaultConditions = {
  timeOfDay: '',
  weatherConditions: {
    weather: 0,
    temperatureDescription: '',
    windDescription: '',
    humidityDescription: '',
    rainDescription: '',
    skyDescription: ''
  }
}

const weatherConditions = [
  { label: 'Sunny', flag: 1 << 0 },
  { label: 'Raining', flag: 1 << 1 },
  { label: 'Clowdy', flag: 1 << 2 },
  { label: 'Snowing', flag: 1 << 3 }
];

export function WeatherEditor({ id, onClose, open }) {
  const [conditions, setConditions] = useState(defaultConditions);

  const handleChange = useCallback((name, value) => {
    if (name !== 'timeOfDay') {
      return setConditions(prev => ({ ...prev, weatherConditions: { ...prev.weatherConditions, [name]: value } }));
    }
    return setConditions(prev => ({ ...prev, [name]: value }));
  }, []);

  const handleSave = useCallback(async () => {
    await putEventConditions(id, conditions);
    onClose();
  }, [onClose, conditions, id]);

  const fetchEvent = useCallback(async () => {
    const event = await getEvent(id);
    setConditions(event.conditions || defaultConditions);
  }, [id]);

  useEffect(() => {
    fetchEvent();
  }, [fetchEvent]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Edit event weather</DialogTitle>
      <DialogContent>
        <Box display='flex' flexDirection='column' gap='12px' minWidth='400px'>
          {/* <TextField
            fullWidth
            name="timeOfDay"
            label="Time of day"
            size="small"
            variant="standard"
            value={conditions.timeOfDay || ''}
            onChange={(e) => handleChange('timeOfDay', e.target.value)}
          /> */}
          <TextField
            fullWidth
            name="skyDescription"
            label="Sky"
            size="small"
            variant="standard"
            type='text'
            value={conditions.weatherConditions.skyDescription || ''}
            onChange={(e) => handleChange('skyDescription', e.target.value)}
          />
          <TextField
            fullWidth
            name="rainDescription"
            label="Rain"
            size="small"
            variant="standard"
            type='text'
            value={conditions.weatherConditions.rainDescription || ''}
            onChange={(e) => handleChange('rainDescription', e.target.value)}
          />
          <TextField
            fullWidth
            name="temperatureDescription"
            label="Temperature"
            size="small"
            variant="standard"
            type='text'
            value={conditions.weatherConditions.temperatureDescription || ''}
            onChange={(e) => handleChange('temperatureDescription', e.target.value)}
          />
          <TextField
            fullWidth
            name="windDescription"
            label="Wind power"
            size="small"
            variant="standard"
            type='text'
            value={conditions.weatherConditions.windDescription || ''}
            onChange={(e) => handleChange('windDescription', e.target.value)}
          />
          {/* <TextField
            fullWidth
            name="humidityDescription"
            label="Humidity"
            size="small"
            variant="standard"
            type='text'
            value={conditions.weatherConditions.humidityDescription || ''}
            onChange={(e) => handleChange('humidityDescription', e.target.value)}
          />
          <Box display='flex' alignItems='center' gap='12px'>
            {weatherConditions.map((item) => <FormControlLabel
              key={item.flag}
              control={
                <Checkbox
                  checked={hasFlag(conditions.weatherConditions.weather, item.flag)}
                  onChange={(e) => handleChange('weather', e.target.checked ? addFlag(conditions.weatherConditions.weather, item.flag) : dropFlag(conditions.weatherConditions.weather, item.flag))}
                />}
              label={item.label} />)}
          </Box> */}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleSave}>
          Save
        </Button>
        <Button autoFocus onClick={onClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
